import * as Yup from "yup";
import { minError, maxError } from "../utils";
export default (t => Yup.object().shape({
  amount: Yup.string().required(`${t.amount} ${t.required}`).matches(/^[0-9]+(\.[0-9]{1,2})?$/gm, `${t.amount} ${t.invalid}`),
  password: Yup.string().required(`${t.password} ${t.required}`).min(4, minError(t.password, 4, t.minError, t.characters)).max(50, maxError(t.password, 50, t.maxError, t.characters))
}));